<template>
    <div class="selectable-input cursor-default flex items-center" @click.stop="toggle">
        <input type="checkbox" class="form-checkbox h-5 w-5 text-blue-600" :checked="value" />
    </div>
</template>

<script>
export default {
    name: 'SelectableInput',
    emits: ['toggle'],
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value: {
            handler(val) {
            }
        }
    },
    methods: {
        toggle() {
            this.$emit('toggle', !this.value);
        },
    }
}
</script>